<div style=" margin:auto;margin-top: 6.5%;width: 99%;">
    <!-- <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar  (productNavToggle)="selectedProductDetails = $event"></app-jsip-product-info-bar> -->

  <div class="Ntabs-wrap" >
  <div *ngFor="let link of navLinks">
      <button
      type="button"
      class="Ntab-btn"
      [class.active]="rla.isActive"
      [routerLink]="link.link" 
      routerLinkActive #rla="routerLinkActive"
      >
      {{link.label}}
    </button>
  </div>
</div>
<div class="outer-div-productdetails productDetailsCollapsed"  style="border: 1px solid #e2e8f0;">

<div class="Ntab-body" style="margin-top: 0%;padding: 0px 16px;">
 <router-outlet></router-outlet>
</div>
</div>
        <!-- <nav mat-tab-nav-bar mat-stretch-tabs style="margin-bottom:2%">
          <a mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="link.link"
              routerLinkActive #rla="routerLinkActive"
              [active]="rla.isActive">
              {{link.label}}
          </a>
        </nav>
        <router-outlet></router-outlet> -->
  
<!-- </div>
</div> -->
</div>

